try {
  function handleImpression(elem) {
    // console.log('[IMPRESSION]', elem);
    // Shopify.analytics.publish(`tt_impression_custom`, elem);
  }
  function getData(elem) {
    var dataAttributes = {};
    try {
      for (let attr of elem.attributes) {
        if (attr.name.startsWith("data-")) {
          dataAttributes[attr.name] = attr.value;
        }
      }
    } catch (error) {}
    return dataAttributes
  }
  const observedElements = new Map();
  var imageObserver = new IntersectionObserver(function (entries, observer) {
  	for (let entry of entries) {
      var elem = entry.target
      // console.log("elem", elem, "isIntersecting", entry.isIntersecting, "intersectionRatio", entry.intersectionRatio)
      if (entry.isIntersecting) {
        if (entry.intersectionRatio >= 0.75) {
          if (!observedElements.has(elem)) {
            observedElements.set(elem, {
              startTime: performance.now(),
              elemInfo: {
                "id": elem.id,
                "className": elem.className,
                "tagName": elem.tagName,
                "data": getData(elem),
                "src": elem.getAttribute('src'),
                "alt": elem.getAttribute('alt')
              }
            });
          }
        }
      } else {
        observedElements.delete(elem);
      }
  	}
  }, {
      root: null,
      rootMargin: "0px",
      threshold: [0.0, 0.75],
  });
  function checkVisibilityDurations() {
    const now = performance.now();
    observedElements.forEach((data, element) => {
      if (now - data.startTime >= 500) {
        handleImpression(data.elemInfo);
        observedElements.delete(element);
      }
    });
    requestAnimationFrame(checkVisibilityDurations);
  }
  requestAnimationFrame(checkVisibilityDurations);

  document.addEventListener("DOMContentLoaded", function(event) {
    var imageElems = document.querySelectorAll('img');
    // console.log("imageElems", imageElems)
    for (var i = 0, len = imageElems.length; i < len; i++) {
      imageObserver.observe(imageElems[i])
    }
  });
} catch (error) {
  console.error("Error in setting up impression tracking", error)
}